import Platform from "@repo/utils-client/Platform";

import { Registration } from "../../client";

export default (platform?: Platform.Key): Registration.Analytics =>
  import("amplitude-js").then(({ default: amplitude }) => {
    const instance = amplitude.getInstance();

    instance.init(import.meta.env.AMPLITUDE_API_KEY, undefined, {
      includeUtm: true,
      includeReferrer: true,
      includeGclid: true,
      includeFbclid: true,
      saveEvents: true,
      ...(platform && { platform: Platform.Key.format(platform) }),
    });

    return {
      track(name, properties) {
        instance.logEvent(name, properties);
      },
      identify(payload) {
        if ("userId" in payload && payload.userId !== undefined)
          instance.setUserId(payload.userId);
        if (payload.properties) instance.setUserProperties(payload.properties);
      },
    };
  });
